<template>
	<modal name="song-playlists" @opened="opened" :width="300" :height="400">
		<div id="song-playlists-modal">
			<template v-if="!Object.keys(playlists).length">
				<p>{{ $t('playlist.songNoPlaylistText') }}</p>
				<button type="button" class="song-playlists-save" @click="$modal.show('create-playlist')">
					<IconPlus/> {{ $t('playlist.create') }}
				</button>
			</template>
			<template v-else>
				<div class="playlists-container">
					<div class="playlists">
						<div v-for="playlist in playlists"
							 v-bind:key="playlist.id"
							 class="playlist"
							 @click="togglePlaylist(playlist)"
							 :class="{ selected: songPlaylists.includes(playlist.id) }">
							<IconCheck />
							{{ playlist.title }}
						</div>
					</div>
				</div>
				<button type="button" class="song-playlists-save" @click="closeModal">{{ $t('global.close') }}</button>
			</template>
		</div>
	</modal>
</template>

<script>
	import { mapState } from "vuex";
	import IconCheck from "@/components/icons/IconCheck"
	import IconPlus from "@/components/icons/IconPlus"
	import { PlaylistService } from "@/services/PlaylistService";

	export default {
		components: {
			IconCheck, IconPlus
		},
		data() {
			return {
				songPlaylists: []
			};
		},
		computed: {
			...mapState([ "playlists", "songsPlaylists", "currentSong" ])
		},
		methods: {
			opened() {
				if (this.currentSong.songId in this.songsPlaylists) {
					this.songPlaylists = this.songsPlaylists[this.currentSong.songId];
				} else {
					this.songPlaylists = [];
				}
			},
			togglePlaylist(playlist) {
				if (!this.songPlaylists.includes(playlist.id)) {
					this.songPlaylists.push(playlist.id);
					PlaylistService.addSongToPlaylist(playlist, this.currentSong);
				} else {
					this.songPlaylists = this.songPlaylists.filter(p => p !== playlist.id);
					PlaylistService.removeSongFromPlaylist(playlist, this.currentSong);
				}
			},
			closeModal() {
				this.$modal.hide("song-playlists");
			}
		}
	}
</script>

<style lang="scss" scoped>
	#song-playlists-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		gap: 5px;

		p {
			margin: 0;
			padding: 20px;
		}

		.playlists-container {
			overflow-y: auto;

			div.playlists {
				div.playlist {
					display: block;
					padding: 20px;
					height: 20px;
					cursor: pointer;
					font-weight: 200;
					color: rgba(255, 255, 255, 0.8);

					.icon {
						fill: white;
						visibility: hidden;
						width: 17px;
						float: left;
						margin: 1px 20px 0 7px;
					}

					&.selected {
						.icon {
							visibility: visible;
						}
					}

					&:hover {
						background-color: rgba(255, 255, 255, 0.21);
					}
				}
			}
		}

		button.song-playlists-save {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 10px;
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background: rgb(233,196,106); /* Old browsers */
			background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 0;
			cursor: pointer;

			&:hover {
				opacity: 0.9;
			}

			&:focus {
				outline: none;
			}

			.icon-plus {
				fill: rgba(255, 255, 255, 0.7);
			}
		}
	}
</style>
